import { useState } from 'react'
import moment from 'moment';
import NACell from '../Reusable/DataTable/NACell';
import Remark from '../Order/Remark';
import Modal from '../Reusable/Modal';
import { useSearchParams } from 'react-router-dom';
import DataTable from './DataTable';

const FilterOrderList = (props: any) => {
  const [openReviewModal, setOpenReviewModal] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState("")
  const [searchParams, setSearchParms] = useSearchParams()

  const checkedAllItems = searchParams.get("selectAllItems") === "1"
  const handleIndividualSelect = (value:string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return
    }
    let itemIndex = selectedItems?.findIndex(item => item === value)
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems?.map(item => item).join(",").toString()
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems")
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value)
      const newSelectedItems = selectedItems?.map(item => item).join(",").toString()
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  }

  const isSelected = (value:string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems) {
      return false
    }
    return selectedItems.includes(value)
  }

  const handleSelectAll = (table:any) => {
    const { options: { data: tableData } } = table
    const isSelected = searchParams.get("selectAllItems")
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData?.map((item:any) => item.id).join(",").toString()
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  }

  let defaultColumns: any = [
    {
      id: 'select',
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className='cursor-pointer'
          />
        )
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className='cursor-pointer'
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className='whitespace-nowrap'>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{moment(row?.original?.created).format('YY-MM-DD HH:mm:ss')}</p>
          </>
        )
      },
    },
    {
      header: "Vendor",
      accessorKey: "vendor.id",
      cell: ({ getValue, row: { original } }: any) => {
        return (
          <p className="capitalize">{original?.is_walking_customer ? original?.sender_full_name : original?.merchant?.profile?.full_name}</p>
        )
      }
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: NACell
    },
    {
      header: "Destination",
      accessorKey: "destination_branch.name",
      cell: NACell
    },
    {
      header: "Customer",
      accessorKey: "customer_full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_full_address}</p>
            <a href={`tel:${row?.original?.customer_mobile_number1}`} className="text-xs text-gray-500 block">{row?.original?.customer_mobile_number1}</a>
            <a href={`tel:${row?.original?.customer_mobile_number2}`} className="text-xs text-gray-500">{row?.original?.customer_mobile_number2}</a>
          </>
        )
      },
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className='whitespace-nowrap'>COD: {row?.original?.cod ?? 0} </p>
            <p className='whitespace-nowrap'>Collected:{row?.original?.collected_cod ?? 0} </p>
            <p className='whitespace-nowrap'>D. Charge:{getValue()}</p>
          </>
        )
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p>{getValue()}<span className="text-gray-500 text-xs">Kgs</span> </p>
          </>
        )
      },
    },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => <button onClick={() => {
        setSelectedOrder(row?.original?.id)
        setOpenReviewModal(true)
      }}>
        {getValue()} Remarks
      </button>
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p className="uppercase">{getValue()}</p>
          </>
        )
      },
    },
  ];

  console.log(props?.API)
  return (
    <>
      <DataTable
        url={props?.API}
        queryKey={props?.API}
        columns={defaultColumns}
        tableName={"orders"}
        isUpload={false}
        isDownload={true}

      />

      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={<>
          <Remark
            selectedOrder={selectedOrder}
          />
        </>}
      />
    </>
  )
}

export default FilterOrderList
